import { render, staticRenderFns } from "./OrgRoutes.vue?vue&type=template&id=5d5706e7&scoped=true&"
import script from "./OrgRoutes.vue?vue&type=script&lang=js&"
export * from "./OrgRoutes.vue?vue&type=script&lang=js&"
import style0 from "./OrgRoutes.css?vue&type=style&index=0&id=5d5706e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5706e7",
  null
  
)

export default component.exports